import React from "react";
import helpBranches from "images/helpBranches.png";

const HlpBranches = () => {
  return (
    <>
      <h1>Branches Appear Here</h1>
      You can message inside branches as well. Admins can create them, and then
      create branches within branches, like the folders on your computer.
      <img
        style={{ marginBottom: "0" }}
        src={helpBranches}
        alt="effice-branches"
      />
    </>
  );
};

export default HlpBranches;
